import AdminLayout from "@/views/admin/AdminLayout.vue"
import AccountingList from "@/views/admin/accounting/AccountingList.vue"
import TransactionList from "@/views/admin/accounting/TransactionList.vue"

const routes = [
  {
    path: "/:lang/accounting",
    component: AdminLayout,

    children: [
      {
        path: "",
        redirect: "account-manage",
        meta: {
          requireAuth: true,
          auth: 0
        }
      },
      {
        path: "account-manage",
        name: "AccountingList",
        component: AccountingList,
        meta: {
          title: "ChartOfAccounts.__ChartOfAccounts",
          requireAuth: true,
          auth: 0
        }
      },
      {
        path: "transactions",
        name: "Transactions",
        component: TransactionList,
        meta: {
          title: "Transactions.__Transactions",
          requireAuth: true,
          auth: 0
        }
      }
    ]
  }
]

export default routes
